import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4"; 

export default function WhatsAppButton() {
  const { t } = useTranslation();

  const whatsappMessage = encodeURIComponent(t("whatsappAutoMessage"));
  const whatsappLink = `https://wa.me/966582076578?text=${whatsappMessage}`;

  const handleWhatsClick = () => {
    ReactGA.event({
      category: "Button",
      action: "Click",
      label: "WhatsApp Clicked",
    });
  };

  return (
    <div className="hidden sm:block fixed bottom-6 right-6 z-50">
      <motion.div
        className="relative group"
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        {/* Tooltip */}
        <div className="absolute bottom-16 right-0 transform translate-y-1 px-4 py-2 text-[15px] font-semibold text-green-700 bg-white rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap drop-shadow-lg">
          💬 {t("chatNow")}
        </div>

        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          onClick={handleWhatsClick}
        >
          <div className="bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl shadow-green-400/40 hover:shadow-green-500/70 transition-all duration-300 ease-in-out cursor-pointer">
            <FaWhatsapp className="text-3xl md:text-4xl animate-bounce" />
          </div>
        </a>
      </motion.div>
    </div>
  );
}
